import { Grid, Container, Tabs, Box, Tab, } from "@mui/material";
import { useState } from "react";
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import { EmailLogin } from "./EmailLogin";
import { MobileLogin } from "./MobileLogin";


const LoginTabs = () => {
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Container disableGutters>
            <Grid container spacing={2} justifyContent="center" sx={{ marginTop: '15px', marginBottom: '20px' }}>
                <Grid size={{ md: 12, xs: 12 }}>
                    {/* Tabs */}
                    <Box
                        sx={{
                            bgcolor: "#f0f0f0",
                            borderRadius: "30px",
                            display: "block",
                            padding: '6px 7px',
                            height: "45px",
                            marginBottom: '20px',
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            sx={{
                                "& .MuiTabs-flexContainer": { borderRadius: "30px" },
                                "& .MuiTab-root": {
                                    textTransform: "none",
                                    borderRadius: "30px",
                                    minWidth: "50%",
                                    fontWeight: 600,
                                    color: "#364252",
                                    padding: "4px 8px",
                                    minHeight: "33px",
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    height: "33px",
                                    "&.Mui-selected": {
                                        bgcolor: "#030213",
                                        color: "#ffffff",
                                        fontFamily: "Segoe UI",
                                        fontSize: "14px",
                                    },
                                },
                                "& .MuiTabs-indicator": { display: "none" },
                            }}
                        >
                            <Tab
                                icon={<MailOutlinedIcon />}
                                label="Email"
                                iconPosition="start"
                                sx={{
                                    textTransform: "none",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            />
                            <Tab
                                icon={<CallOutlinedIcon />}
                                label="Phone"
                                iconPosition="start"
                                sx={{
                                    textTransform: "none",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            />
                        </Tabs>
                    </Box>

                    {value === 0 && (
                        <EmailLogin />
                    )}
                    {value === 1 && (
                        <MobileLogin />
                    )}
                </Grid>
            </Grid>
        </Container>
    );
};

export default LoginTabs;
